'use client';

import { createContext } from 'react';

import type { AccordionRootContextInterface } from '../types/accordion-root.types';

export const AccordionRootContext = createContext<AccordionRootContextInterface>({});

AccordionRootContext.displayName = 'Accordion.Root.Context';
